import { render, staticRenderFns } from "./ShowOrHideButtonComponent.vue?vue&type=template&id=ff7287c4&scoped=true&lang=pug"
import script from "./ShowOrHideButtonComponent.vue?vue&type=script&lang=ts"
export * from "./ShowOrHideButtonComponent.vue?vue&type=script&lang=ts"
import style0 from "./ShowOrHideButtonComponent.vue?vue&type=style&index=0&id=ff7287c4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff7287c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff7287c4')) {
      api.createRecord('ff7287c4', component.options)
    } else {
      api.reload('ff7287c4', component.options)
    }
    module.hot.accept("./ShowOrHideButtonComponent.vue?vue&type=template&id=ff7287c4&scoped=true&lang=pug", function () {
      api.rerender('ff7287c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShowOrHideButton/ShowOrHideButtonComponent.vue"
export default component.exports